// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"158a8d62","732":"d6c6d4ca","977":"dc07e94c"}[chunkId] + ".chunk.js";
};